import { useRequestHeaders, useState } from 'nuxt/app'

/**
 * Set by ClientPortal's front server on every request it hands to this app for an
 * AI App Builder vibe app (and stripped from every other request).
 */
export const VIBE_HOST_HEADER = 'x-ai-builder-app'

/**
 * True when this page is ClientPortal's Communities served on an AI App Builder vibe
 * app's host: ClientPortal owns only `/communities`, every other path is the vibe app.
 *
 * Read from the request header during SSR and carried to the client in Nuxt state, so
 * hydration sees the same value. False wherever the header is absent.
 */
export const useVibeHost = (): boolean =>
  useState('cp-vibe-host', () => useRequestHeaders([VIBE_HOST_HEADER])[VIBE_HOST_HEADER] === '1').value
